import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { Overlay } from '@/components/UI/Overlay';
import {
  navItemsColumnStyles,
  navItemLeftIconStyles,
} from '@/components/BurgerNav/BurgerNav.styles';
import { ChangeLang } from '@/components/ChangeLang/ChangeLang';

export const DesktopNavWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  bottom: -267px;
  width: 100%;
  height: 267px;
  border-top: 1px solid ${({ theme }) => theme.palette.secondary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
  transition: 0.3s ease-in-out;
  z-index: 1;
`;

export const DesktopNavigation = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 30px;

  @media (min-width: 1080px) {
    max-width: 1020px;
    margin: 0;
  }
`;

export const DesktopNavClose = styled(Button)`
  margin-left: auto;
`;

export const DesktopNavColumns = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 520px;
`;

export const DesktopNavColumn = styled.div<{
  $isLeftContent?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 25px;

  ${({ $isLeftContent }) =>
    $isLeftContent &&
    css`
      width: auto;
      gap: 15px;
      align-items: flex-end;
    `}
`;

export const DesktopNavItems = styled.div<{
  $isRow?: boolean;
  $gap?: number;
  $isFooter?: boolean;
}>`
  display: flex;
  gap: ${({ $gap }) => $gap ?? 0}px;

  ${({ $isRow }) => !$isRow && navItemsColumnStyles}
`;

export const DesktopNavItem = styled.div<{
  $leftIcon?: {
    name: string;
    width?: number;
    height?: number;
    margin?: string;
    transition?: string;
  };
}>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;
  line-height: 19px;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.primary.labels};
  cursor: pointer;
  transition: 0.1s linear;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};

    &::before {
      background-color: ${({ theme }) => theme.palette.brand.main};
    }

    & > button p {
      color: ${({ theme }) => theme.palette.brand.main};
    }
  }

  & > button p {
    line-height: 19px;
    font-size: 16px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  ${({ $leftIcon }) => $leftIcon && navItemLeftIconStyles($leftIcon)}
`;

export const DesktopNavChangeLang = styled(ChangeLang)`
  font-family: Arial;
`;

export const ConnectWithUsTitle = styled(Typography.Body)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  &:hover {
    color: ${({ theme }) => theme.palette.secondary.labels};
  }
`;

export const DesktopNavOverlay = styled(Overlay)`
  transition: none;
  z-index: 9;
`;
